import { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Componentes de logística
import DashboardLogistica from "./components/DashboardLogistica";
import RutasDespachos from "./components/RutasDespachos";
import FlotasVehiculos from "./components/FlotasVehiculos";
import Conductores from "./components/Conductores";
import OrdenesEnvio from "./components/OrdenesEnvio";
import ZonasDistribucion from "./components/ZonasDistribucion";
import ReportesLogistica from "./components/ReportesLogistica";

import { useMaterialUIController } from "context";

export default function Logistica() {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderContent = () => {
    switch (tabValue) {
      case 0:
        return <DashboardLogistica />;
      case 1:
        return <RutasDespachos />;
      case 2:
        return <FlotasVehiculos />;
      case 3:
        return <Conductores />;
      case 4:
        return <OrdenesEnvio />;
      case 5:
        return <ZonasDistribucion />;
      case 6:
        return <ReportesLogistica />;
      default:
        return <DashboardLogistica />;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Módulo de Logística y Distribución
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  sx={{ px: 3 }}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  <Tab label="Dashboard" icon={<Icon>dashboard</Icon>} iconPosition="start" />
                  <Tab label="Rutas y Despachos" icon={<Icon>route</Icon>} iconPosition="start" />
                  <Tab
                    label="Flotas y Vehículos"
                    icon={<Icon>local_shipping</Icon>}
                    iconPosition="start"
                  />
                  <Tab label="Conductores" icon={<Icon>badge</Icon>} iconPosition="start" />
                  <Tab
                    label="Órdenes de Envío"
                    icon={<Icon>inventory_2</Icon>}
                    iconPosition="start"
                  />
                  <Tab label="Zonas de Distribución" icon={<Icon>map</Icon>} iconPosition="start" />
                  <Tab label="Reportes" icon={<Icon>assessment</Icon>} iconPosition="start" />
                </Tabs>
              </MDBox>
              <MDBox p={3}>{renderContent()}</MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
